import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {authSteps} from "./authSteps";
import TimeEscaped from "./TimeEscaped";

function CodeWaiting(props) {
    const [visible, setVisible] = useState(false)
    const [loaderSendCode, setLoaderSendCode] = useState(false)

    useEffect(() => {

        if (props.step === authSteps.STATE_CODE_WAITING || props.step === authSteps.STATE_CODE_REUSED) {
            setVisible(true)
        } else {
            setVisible(false)
        }
    }, [props?.step]);

    useEffect(() => {
        if (props.rootForm.current === undefined) {
            return
        }

        //TODO подключение через npm а не через глобальный контекст
        const node = document.querySelector('.auth_code')
        node.value = '';
        const mask = Array(props.codeLength).fill("9").join(" ");
        const im = new Inputmask(mask, {
            oncomplete: function () {
                let codeVal = node.value
                codeVal = codeVal.replace(/\s/g, '');
                node.value = codeVal;

                sendGetCode();
            },
            onBeforePaste: function (pastedValue, opts) {
                const code = pastedValue.replace(/\s/g, '')
                setTimeout(function () {

                    const codeRegex = new RegExp(`^\\d{${props.codeLength}}$`);
                    if (code.length === props.codeLength && codeRegex.test(code)) {
                        opts.oncomplete();
                    }
                }, 100)
                return code
            },
            clearIncomplete: false,
            autoUnmask: true,
        })
        im.mask(node);

    }, [visible]);

    const sendGetCode = () => {
        let data;
        if (props.rootForm.current) {
            data = Object.fromEntries(new FormData(props.rootForm.current.querySelector("#ctweb-smsauth_form_phone")));
            data.is_ajax_post = 'Y'
            data.PROVIDER_TYPE = props.type
            data.PHONE = data.PHONE.replace(/\D/g, "").substr(data.__phone_prefix.length)
            data.CODE = data.CODE.replace(/\s/g, "")
            if (props.isRegister) {
                let data_register = Object.fromEntries(new FormData(document.querySelector("#bx_2930803142__form")));
                data = {...data_register, ...data}
            }
            if (props.isChangePhone) {
                data.PROFILE_AUTH = 'Y'
            }

            if (window.recaptcha !== undefined) {
                data.recaptcha_token = window.recaptcha.getToken()
            }
        }
        setLoaderSendCode(true)
        axios.post('/local/components/ctweb/sms.authorize/ajax.php',
            data
            , {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                }
            }
        ).then(response => {
            props.setStep(response.data.STEP);
            if (response.data.STEP === authSteps.STATE_SUCCESS) {
                props.setMessage(response.data.MESSAGE ?? '')
                window.location.reload();
                return
            }
            props.setReuseTime(response.data.REUSE_TIME)

            if (response.data.ERRORS.length > 0) {
                props.setErrors(response.data.ERRORS);
            } else {
                props.setErrors([])
            }
            setLoaderSendCode(false)
        }).catch(error => {
            props.setErrors([{CODE:'FORM_ERROR', TEXT:'На сайте произошла ошибка'}])
        })
    }

    return (
        <div className={"flex-col justify-center items-center mb-3 " + (visible ? 'block' : 'hidden')}>
            <div className="max-w-xs flex flex-col items-center justify-center w-full">

                <div className="form-group flex flex-col">
                    <div className="flex flex-row justify-between">
                        <label className="font-medium mb-2 text-textLight
                                        dark:text-white text-base"
                               for="sms-auth-code">{/*<?= GetMessage("SMS_AUTH_CODE") ?>*/}Введите код</label>
                        <a className="font-medium mb-2 text-textLight
                                        dark:text-white underline text-xs"
                           onClick={props.onChangePhone}>
                            {/*<?= GetMessage("SMS_AUTH_CHANGE_NUMBER_PHONE") ?>*/}Изменить номер</a>
                    </div>
                    <div className="relative">
                        <input type="text" name="CODE" id="bx_934924412_code"
                               className="form-control bg-textDark p-3 mb-2 dark:bg-grayButton cursor-pointer
                                                    w-full text-textLight rounded-md text-center
                                                    dark:text-white border-0 text-xl auth_code" autoComplete="off"/>
                        {loaderSendCode && <div className="absolute top-4 right-0 flex items-center pr-3">
                            <svg
                                className="animate-spin h-5 w-5 text-gray-400"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                ></circle>
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                ></path>
                            </svg>
                        </div>}
                    </div>

                    <span id="result"></span>
                </div>
                <TimeEscaped onEndTimer={props.onEndTimer} step={props.step} reuseTime={props.reuseTime}/>
            </div>
        </div>
    );
}

export default CodeWaiting;